// extracted by mini-css-extract-plugin
module.exports = {"label":"by_d","mobileOnly":"by_hr","content":"by_s","toggle":"by_hs","darkMode":"by_cN"};